class ProductSportController extends HTMLElement {
  constructor() {
    super();
    this.variantColorTargets = [];
    this.imageTarget = null;
    this.priceTarget = null;
    this.priceFinalTarget = null;
    this.priceCompareTarget = null;
    this.productLinkTarget = null;
  }

  connectedCallback() {
    setTimeout(() => {
      this.initializeTargets();
      this.setupEventListeners();
    }, 100);
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  initializeTargets() {
    this.variantColorTargets = this.querySelectorAll(
      '[data-product_sport-target="variantColor"]'
    );
    this.imageTarget = this.querySelector(
      '[data-product_sport-target="image"]'
    );
    this.priceTarget = this.querySelector(
      '[data-product_sport-target="price"]'
    );
    this.priceFinalTarget = this.querySelector(
      '[data-product_sport-target="priceFinal"]'
    );
    this.priceCompareTarget = this.querySelector(
      '[data-product_sport-target="priceCompare"]'
    );
    this.productLinkTarget = this.querySelector(
      '[data-product_sport-target="productLink"]'
    );
  }

  setupEventListeners() {
    this.variantColorTargets.forEach(variantElement => {
      variantElement.addEventListener('click', event => {
        this.changeVariant(event);
      });
    });

    if (this.productLinkTarget) {
      this.productLinkTarget.addEventListener('click', event => {
        this.goToProduct(event);
      });
    }
  }

  removeEventListeners() {}

  goToProduct(event) {
    const { productLink, variantId } = event.currentTarget.dataset;
    window.location.href = `${productLink}?variant=${variantId}`;
  }

  changeVariant(event) {
    const dataset = event.currentTarget.dataset;
    const { variantId, productId } = dataset;

    this.updateImage(dataset, this.imageTarget);
    this.updatePrice(dataset);
    this.setActiveVariant(productId, variantId, this.productLinkTarget);
  }

  setActiveVariant(productId, variantId, productLinkTarget) {
    this.variantColorTargets.forEach(variantElement => {
      const dataset = variantElement.dataset;
      if (dataset.productId == productId) {
        variantElement.classList.remove('active');
        if (dataset.variantId === variantId) {
          variantElement.classList.add('active');
        }
      }
    });

    if (productLinkTarget) {
      productLinkTarget.setAttribute('data-variant-id', variantId);
    }
  }

  updateImage(dataset, imageTarget) {
    const { variantImage, variantTitle, productTitle } = dataset;

    if (variantImage && imageTarget) {
      if (variantImage.includes('lookbook')) {
        imageTarget.classList.remove('mix-blend-mode');
      } else {
        imageTarget.classList.add('mix-blend-mode');
      }

      imageTarget.setAttribute('src', variantImage);

      if (variantTitle || productTitle) {
        imageTarget.alt = `Imagem da variante ${variantTitle} do produto ${productTitle}`;
      }
    }
  }

  /**
   * @param {DOMStringMap} dataset
   */
  updatePrice(dataset) {
    const priceInCents = Number(dataset.variantPrice || 0);
    const compareInCents = Number(dataset.variantComparePrice || 0);

    if (this.priceFinalTarget) {
      this.priceFinalTarget.textContent = this.formatMoney(priceInCents);
    }

    if (!this.priceCompareTarget) return;

    if (compareInCents > priceInCents) {
      this.priceCompareTarget.textContent = this.formatMoney(compareInCents);
      this.priceCompareTarget.hidden = false;
      return;
    }

    this.priceCompareTarget.hidden = true;
    this.priceCompareTarget.textContent = '';
  }

  /**
   * @param {number} priceInCents
   * @returns {string}
   */
  formatMoney(priceInCents) {
    return `R$${(priceInCents / 100).toFixed(0).replace('.', ',')}`;
  }
}

customElements.define('product-sport-controller', ProductSportController);
